export default __webpack_public_path__ + "images/cd-e5fd4d1225cc6c53b73d7b6f037aafeb.svg";